import { Inject, Injectable } from '@angular/core';
import {
  DealStatScale,
  MONITOR_GATEWAY,
  MonitorGateway,
} from '@prlw/core/monitor/monitor.gateway';
import { Observable } from 'rxjs';
import { DealStat } from '@prlw/core/monitor/deal-stat.entity';
import {
  observableWithPending,
  TObservableWithPending,
} from '@prlw/infrastructure/observableWithPending-v2';

@Injectable({
  providedIn: 'root',
})
export class DealsStatsService {
  constructor(
    @Inject(MONITOR_GATEWAY) private readonly gateway: MonitorGateway,
  ) {}

  public dealsStats$(
    instrumentCode: string,
    scale: DealStatScale,
  ): Observable<TObservableWithPending<DealStat[]>> {
    return observableWithPending(
      this.gateway.getDealsStats(instrumentCode, scale),
    );
  }
}
